import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { faqs } from "../data/faqs";
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="cream" labelledBy="faq-title" narrow cta="Yes, I want Facelift Blueprint™" data-id="element-108" data-mp="1ntzwd4buliz7">
      <SectionHeading id="faq-title" title="Frequently Asked Questions" data-id="element-109" data-mp="2bjuarqbtfflk" />

      <div className="mt-10 divide-y divide-line overflow-hidden rounded-3xl border border-line bg-white" data-id="element-110" data-mp="2flxvz6oadyk1">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-111" data-mp="26tnmjrl7tx3u" data-mpi={i}>
              <h3 data-id="element-112" data-mp="26sucohqymrhh">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-base font-bold text-ink focus:outline-none focus-visible:bg-sand sm:px-7" data-id="element-113" data-mp="26sch7nc4gham">
                  {f.q}
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-114" data-mp="1rq0o54kj8sn5" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-115" data-mp="2fcpca804xhc7">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-116" data-mp="2af710aynaq11">
                    <div className="space-y-3 px-5 pb-6 text-[15px] leading-relaxed text-muted sm:px-7" data-id="element-117" data-mp="p1ceh8n24wyj">
                      {f.a.map(p => <p key={p} data-id="element-118" data-mp="2p4vklfxabxlh">{p}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}